module.exports = __webpack_public_path__ + "img/send-money.aa6b33e9.png";